import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  nav: {
    width: "250px",
    padding: theme.spacing(4, 0),
    boxSizing: "border-box",
    borderRight: `1px solid ${theme.palette.secondary.main}`,
  },
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  appBarSpacer: theme.mixins.toolbar,
}));
